import { resolvePriceChangeStyle } from "./priceChangeStyle.js";
import { extractRecipeSizeLabel } from "./recipeCatalogTags.js";

export type PricingProductFacets = {
  group: string;
  style: string;
  size: string;
};

/** Unique labels, first-seen casing, case-insensitive. */
export function uniqueFacetLabels(values: Iterable<string>): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of values) {
    const t = raw.trim();
    if (!t) continue;
    const key = t.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(t);
  }
  return out.sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "base" }));
}

export function facetSetHas(selected: ReadonlySet<string>, value: string): boolean {
  if (selected.size === 0) return true;
  const v = value.trim().toLowerCase();
  if (!v) return false;
  for (const s of selected) {
    if (s.trim().toLowerCase() === v) return true;
  }
  return false;
}

/**
 * COGS filter facets. Style is Utility, Lofted, or Studio.
 * Width tags such as 8w are not styles. Group and size still fall back to the build model.
 */
export function resolvePricingProductFacets(input: {
  groupName?: string | null;
  groupCode?: string | null;
  tags?: readonly string[];
  recipeCode?: string;
  recipeName?: string;
  buildSeries?: string | null;
  buildRoofStyle?: string | null;
  buildSizeBand?: string | null;
}): PricingProductFacets {
  const group = (input.groupName || input.groupCode || input.buildSeries || "").trim();
  const style = resolvePriceChangeStyle({
    recipeCode: input.recipeCode,
    recipeName: input.recipeName,
    tags: input.tags,
    buildRoofStyle: input.buildRoofStyle,
  });
  const size = (
    extractRecipeSizeLabel({
      code: input.recipeCode ?? "",
      name: input.recipeName ?? "",
      tags: input.tags,
    }) ||
    input.buildSizeBand ||
    ""
  ).trim();
  return { group, style, size };
}
